<template>
  <div class="count_class">
    <count-to ref="countTo" :end-val="endVal" :className="getClass">
      <template v-slot:left>
        <span class="prefix-style">总金额： </span>
      </template>
      <template v-slot:right>
        <span> 元</span>
      </template>
    </count-to>
    <br />
    <el-button type="primary" round @click="getNumber">获取数值</el-button>
    <el-button type="primary" round @click="updateVal">更新值</el-button>
  </div>
</template>
<script>
import CountTo from '@/components/ForTest/CountTo.vue';

export default {
  name: 'count_to',
  components: {
    CountTo,
  },
  data() {
    return {
      endVal: 1000,
    };
  },
  computed: {
    // 返回自定义样式
    getClass() {
      return ['count-to-number'];
    },
  },
  methods: {
    getNumber() {
      const number = this.$refs.countTo.getCount();
      this.$message({
        message: `当前数值为：${number}`,
        type: 'success',
      });
      console.log(number);
    },
    updateVal() {
      this.endVal += Math.random() * 100;
    },
  },
};
</script>
